"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var RootComponent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RootComponent, _React$Component);

  function RootComponent(props) {
    var _this;

    _classCallCheck(this, RootComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RootComponent).call(this, props));
    props.connector.subscribe(_this.onStateChange.bind(_assertThisInitialized(_assertThisInitialized(_this))));
    return _this;
  }

  _createClass(RootComponent, [{
    key: "onStateChange",
    value: function onStateChange() {
      this.setState({});
    }
    /**
     * Render the matching route.
     */

  }, {
    key: "render",
    value: function render() {
      var component = this.props.connector.componentResolver.getComponent();

      if (!component) {
        return null;
      }

      return _react.default.createElement(component, _objectSpread({}, this.props));
    }
  }]);

  return RootComponent;
}(_react.default.Component);

exports.default = RootComponent;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9saWIvUm9vdENvbXBvbmVudC5qcyJdLCJuYW1lcyI6WyJSb290Q29tcG9uZW50IiwicHJvcHMiLCJjb25uZWN0b3IiLCJzdWJzY3JpYmUiLCJvblN0YXRlQ2hhbmdlIiwiYmluZCIsInNldFN0YXRlIiwiY29tcG9uZW50IiwiY29tcG9uZW50UmVzb2x2ZXIiLCJnZXRDb21wb25lbnQiLCJSZWFjdCIsImNyZWF0ZUVsZW1lbnQiLCJDb21wb25lbnQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUFFcUJBLGE7Ozs7O0FBQ25CLHlCQUFZQyxLQUFaLEVBQW1CO0FBQUE7O0FBQUE7O0FBQ2pCLHVGQUFNQSxLQUFOO0FBQ0FBLElBQUFBLEtBQUssQ0FBQ0MsU0FBTixDQUFnQkMsU0FBaEIsQ0FBMEIsTUFBS0MsYUFBTCxDQUFtQkMsSUFBbkIsdURBQTFCO0FBRmlCO0FBR2xCOzs7O29DQUVlO0FBQ2QsV0FBS0MsUUFBTCxDQUFjLEVBQWQ7QUFDRDtBQUVEOzs7Ozs7NkJBR1M7QUFDUCxVQUFNQyxTQUFTLEdBQUcsS0FBS04sS0FBTCxDQUFXQyxTQUFYLENBQXFCTSxpQkFBckIsQ0FBdUNDLFlBQXZDLEVBQWxCOztBQUNBLFVBQUksQ0FBQ0YsU0FBTCxFQUFnQjtBQUNkLGVBQU8sSUFBUDtBQUNEOztBQUVELGFBQU9HLGVBQU1DLGFBQU4sQ0FBb0JKLFNBQXBCLG9CQUFvQyxLQUFLTixLQUF6QyxFQUFQO0FBQ0Q7Ozs7RUFwQndDUyxlQUFNRSxTIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBSb290Q29tcG9uZW50IGV4dGVuZHMgUmVhY3QuQ29tcG9uZW50IHtcbiAgY29uc3RydWN0b3IocHJvcHMpIHtcbiAgICBzdXBlcihwcm9wcyk7XG4gICAgcHJvcHMuY29ubmVjdG9yLnN1YnNjcmliZSh0aGlzLm9uU3RhdGVDaGFuZ2UuYmluZCh0aGlzKSk7XG4gIH1cblxuICBvblN0YXRlQ2hhbmdlKCkge1xuICAgIHRoaXMuc2V0U3RhdGUoe30pO1xuICB9XG5cbiAgLyoqXG4gICAqIFJlbmRlciB0aGUgbWF0Y2hpbmcgcm91dGUuXG4gICAqL1xuICByZW5kZXIoKSB7XG4gICAgY29uc3QgY29tcG9uZW50ID0gdGhpcy5wcm9wcy5jb25uZWN0b3IuY29tcG9uZW50UmVzb2x2ZXIuZ2V0Q29tcG9uZW50KCk7XG4gICAgaWYgKCFjb21wb25lbnQpIHtcbiAgICAgIHJldHVybiBudWxsO1xuICAgIH1cblxuICAgIHJldHVybiBSZWFjdC5jcmVhdGVFbGVtZW50KGNvbXBvbmVudCwgeyAuLi50aGlzLnByb3BzIH0pO1xuICB9XG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./node_modules/async-react-router/lib/RootComponent.js
// module id = 62
// module chunks = 0